module.exports = __webpack_public_path__ + "static/media/home_title.75950174.png";